export enum ChipType {
  INCLUDED,
  EXCLUDED,
}
